module.exports = __webpack_public_path__ + "static/img/hover9.b839fd48.png";